import { gql } from '@apollo/client';

/**
 * 移除 AOI 关联地址 (按 addressCoreIds 批量)。
 */
export const REMOVE_AOI_RELATED_ADDRESSES = gql`
  mutation RemoveAoiRelatedAddresses($input: AoiRemoveRelatedAddressesInput!) {
    removeAoiRelatedAddresses(input: $input) {
      affectedRows
    }
  }
`;

export interface AoiRemoveRelatedAddressesInput {
    aoiId: number;
    zipcode: string;
    addressCoreIds: number[];
}

export interface RemoveAoiRelatedAddressesResponse {
    removeAoiRelatedAddresses: {
        affectedRows: number;
    };
}
